import { getMethod, putMethod } from "../../api-service/api-service";
import {
    fetchCategoriesStart,
    fetchCategoriesSuccess,
    fetchCategoriesFail,
    addFilterToCategory,
    addFilterGroupToCategory,
    toggleEasyAccess,
    setError
} from "./categorySlice";

/* ================= FETCH ALL CATEGORIES ================= */
export const fetchAdminCategories = () => async (dispatch) => {
    try {
        dispatch(fetchCategoriesStart());

        const res = await getMethod("/category/admin/fetch-all");

        if (res?.success === true) {
            dispatch(fetchCategoriesSuccess(res?.categories));
            return { success: true, categories: res?.categories };
        } else {
            dispatch(fetchCategoriesFail("No categories found"));
            return { success: false, message: "No categories found" };
        }
    } catch (error) {
        const message = error?.response?.data?.message || error.message || "Failed to fetch categories";
        dispatch(fetchCategoriesFail(message));
        return { success: false, message };
    }
};

/* ================= ASSIGN EASY ACCESS FILTER ================= */
export const assignEasyAccessFilterAction = (categoryId, filterId, filterName) => async (dispatch) => {
    try {
        const res = await putMethod(`/filter/${filterId}/easy-access`, { categoryId });

        if (res.success) {
            // Pass filterName so Redux can add it immediately
            dispatch(toggleEasyAccess({ categoryId, filterId, filterName }));
        }

        return res;
    } catch (error) {
        console.error("Easy access update failed", error);
        dispatch(setError(error.message || "Failed to update easy access"));
        return { success: false, message: error.message };
    }
};

/* ================= ADD FILTER TO CATEGORY ================= */
export const addFilterToCategoryAction = (categoryId, groupId, filterId, filterName) => async (dispatch) => {
    try {
        const res = await putMethod(`/filter/${filterId}/categories`, { categoryIds: [categoryId] });

        // Update Redux only if API succeeds
        if (res.success) {
            dispatch(addFilterToCategory({
                categoryId,
                groupId,
                filter: { _id: filterId, name: filterName }
            }));
        }

        return res;
    } catch (error) {
        console.error("Failed to add filter to category", error);
        dispatch(setError(error.message || "Failed to add filter to category"));
        return { success: false, message: error.message };
    }
};

/* ================= ADD FILTER GROUP TO CATEGORY ================= */
export const addFilterGroupToCategoryAction = (categoryId, filterGroupId, filterGroupName) => async (dispatch) => {
    try {
        const res = await putMethod(`/filter-group/${filterGroupId}/categories`, { categoryIds: [categoryId] });

        // Update Redux only if API succeeds
        if (res.success) {
            dispatch(addFilterGroupToCategory({
                categoryId,
                filterGroup: { _id: filterGroupId, name: filterGroupName }
            }));
        }

        return res;
    } catch (error) {
        console.error("Failed to add filter group to category", error);
        dispatch(setError(error.message || "Failed to add filter group to category"));
        return { success: false, message: error.message };
    }
};

export const updateCategoryAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/category/${id}`, data);

        if (response.success) {
            // Refresh categories after update
            dispatch(fetchAdminCategories());
            return { success: true, category: response.category };
        }

        return { success: false, message: response.message };
    } catch (error) {
        console.error('Error updating category:', error);
        return { success: false, message: error.message };
    }
};